import styled from 'styled-components';
import tw from 'twin.macro';

import { colors } from '@nw/shared/ui';

export const OTPDescriptionText = styled.span`
  ${tw`text-sm leading-5 font-normal font-inter self-start text-blue-gray-500 mt-2 mb-2`}
`;

export const PhoneNumberText = styled.span`
  ${tw`font-inter text-sm font-semibold leading-5`}
  color: ${colors.blackCoral};
`;
